/**
@ngdoc directive
@name uniquePattern

@description
Unique value validation.<br />
It utilises ng-pattern Angular native validator, so you need to add ng-patter="uniquePattern" to the form field.
(At some point it maybe worth to rewrite this to custom validator, have run out of time at this point as it doesn't look as a quick job).

@param {Object} unique-pattern the object to iterate through
@param {string} unique-pattern-property the object property to check
@param {string=} unique-pattern-replace this should be used if the field's model is separate to the object we iterate on (ie. locators add sub-form)

@usage
<select
...
unique-pattern="ngModel" unique-pattern-property="department"
ng-pattern="uniquePattern"
validation-messages="{'pattern': 'Please select unique Department.'}"
...
>...</select>

*/
(function() {

    var uniquePattern = function($timeout) {
        return {
            scope: true,
            bindToController: {
                uniquePattern: '&',
                uniquePatternProperty: '@',
                uniquePatternReplace: '@'
            },
            controller: function(){},
            controllerAs: 'uniquePatternCtrl',
            require: ['ngModel', 'uniquePattern'],
            link: function(scope, elm, attrs, ctrls) {

                if( !angular.isDefined(attrs.ngPattern) && attrs.ngPattern!="uniquePattern"){
                    throw 'ng-pattern="uniquePattern" needs to be set on the element!'
                }
                if( angular.isDefined(attrs.xmsAutocomplete) ){
                    if( !angular.isDefined(attrs.typeaheadOnSelect) || attrs.typeaheadOnSelect.indexOf('autocompleteUniqueValidate') === -1){
                        throw 'Please add typeahead-on-select="autocompleteUniqueValidate()" to xmsAutocomplete field.';
                    }
                }

                var ngModelCtrl = ctrls[0],
                    ctrl        = ctrls[1];
                var valueChanged = false;
                scope.uniquePattern="[\s\S]+"; // allow everything (cannot be empty as it will mess xms-validation)

                function modelWatch() {
                    return scope.$watch(
                        function(){
                            return ctrl.uniquePattern();
                        },
                        function(newVal, oldVal) {
                            // this might be limited to the changes in uniquePatternProperty only
                            // so this will not revalidate if the other fields of the table are changed
                            // (in case ctrl.uniquePattern() is ngModel of xms-table)
                            if(newVal!=oldVal) {

                                if(valueChanged){
                                    validate();
                                    valueChanged = false;
                                } else {
                                    $timeout(function(){
                                        validate();
                                    },1); // 1 to make sure this is done at the end after all models updates
                                }

                            }
                        },
                        true
                    );
                }
                modelWatch();

                scope.$watch(
                    function(){
                        return ngModelCtrl.$viewValue;
                    },
                    function(newVal, oldVal) {
                        if(newVal!=oldVal) {
                            if( !angular.isDefined(attrs.xmsAutocomplete) ){ // for xmsAutocomplete see below
                                valueChanged = true;
                            }
                        }
                    }
                );
                // this is for xmsAutocomplete only and needs to be happening on select:
                // typeahead-on-select="autocompleteUniqueValidate()"
                scope.autocompleteUniqueValidate = function(){
                    console.log('autocomplete value changed!!');
                    valueChanged = true;
                }

                $timeout(function(){
                    validate();
                });


                var makeUniquePattern = function(objArray, property){
                    var pattern = "";
                    if( objArray && objArray!={} ){
                        angular.forEach(objArray, function(value){
                            if(angular.isDefined(value[property])){
                                if( !angular.isDefined(attrs.xmsAutocomplete) ) {
                                    pattern += '(?!^'+value[property]+'$)';
                                } else {
                                    pattern += '(?!^'+value[property]['value']+'$)';
                                }
                            }
                        });
                        pattern = '^('+pattern+'.)*$';
                    }
                    return pattern;
                }

                var validate = function(){
                    var pattern = makeUniquePattern( ctrl.uniquePattern(), ctrl.uniquePatternProperty );

                    if(angular.isDefined(ngModelCtrl.$modelValue)
                        && (!angular.isDefined(ctrl.uniquePatternReplace) || ctrl.uniquePatternReplace!="false") ){ // by default
                            pattern = pattern.replace('(?!^'+ngModelCtrl.$viewValue+'$)','');
                    }
                    scope.uniquePattern = pattern; // this is used by ng-pattern

                    // the following must be done for autocomplete otherwise the field we selected becomes valid
                    // and the other fields becomes invalid (it happens because the the whole ngModel for autcomplete is set on selection,
                    // but not ngModelCtrl.$modelValue for some reason)
                    if( angular.isDefined(attrs.xmsAutocomplete) && valueChanged){
                        console.log('xmsAutocomplete validate()');
                        var patternRegExp = new RegExp(pattern);

                        if( !patternRegExp.test(ngModelCtrl.$viewValue) ){
                            ngModelCtrl.$setValidity('pattern', false);
                            if( !(ngModelCtrl.$options && ngModelCtrl.$options.getOption('allowInvalid')) ){
                                // if !allowInvalid (and by default) do empty modelValue
                                ngModelCtrl.$modelValue = undefined;
                                ngModelCtrl.$$writeModelToScope();
                            }
                        }

                    }
                }


            }
         };
    }
    uniquePattern.$inject = ['$timeout'];
    angular.module('app').directive('uniquePattern', uniquePattern);

}());
